import api from './axiosConfig';

export const parametricasService = {
  getPaises:              () => api.get('/pos/paises').then(r => r.data),
  getDepartamentos:       (paisId?: number) => api.get('/pos/departamentos', { params: { paisId } }).then(r => r.data),
  getMunicipios:          (departamentoId?: number, buscar?: string) =>
    api.get('/pos/municipios', { params: { departamentoId, buscar } }).then(r => r.data),
  getMunicipioById:       (id: number) => api.get(`/pos/municipios/${id}`).then(r => r.data),
  getTiposDocumento:      () => api.get('/pos/tipos-documento-identidad').then(r => r.data),
  getMonedas:             () => api.get('/pos/parametricas/monedas').then(r => r.data),
  getRegimenes:           () => api.get('/pos/parametricas/regimenes-tributarios').then(r => r.data),
  getTarifasIVA:          () => api.get('/pos/parametricas/tarifas-iva').then(r => r.data),
  getUnidadesMedida:      () => api.get('/pos/parametricas/unidades-medida').then(r => r.data),
  getFormasPagoDIAN:      () => api.get('/pos/parametricas/formas-pago-dian').then(r => r.data),
  getMediosPagoDIAN:      () => api.get('/pos/parametricas/medios-pago-dian').then(r => r.data),
  getTiposOperacionDIAN:  () => api.get('/pos/parametricas/tipos-operacion-dian').then(r => r.data),
  getTiposEntidad:        () => api.get('/pos/parametricas/tipos-entidad').then(r => r.data),
  getTiposOrganizacion:   () => api.get('/pos/parametricas/tipos-organizacion').then(r => r.data),
  getTarifasReteFuente:   () => api.get('/pos/parametricas/tarifas-retefuente').then(r => r.data),
  getValoresUVT:          () => api.get('/pos/parametricas/valores-uvt').then(r => r.data),
  getTiposPromocion:      () => api.get('/pos/parametricas/tipos-promocion').then(r => r.data),
};
